import React, { useState } from "react";

// App
import { decodeHtmlEntities } from "../utils/helpers";

// UI
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Input,
} from "@mui/material";
import { ChevronRight } from "@mui/icons-material";
import { NestedMenuItem } from "mui-nested-menu";

const input_font_size = 14;

export default function NestedCategory(props) {
  const [open, setOpen] = useState(false);

  const allCategoryValues = React.useMemo(() => {
    // only include real taxonomy IDs, skip 0 because "All Categories" is added manually
    return props.categories.map((c) => c.value);
  }, [props.categories]);

  const renderMenuItems = (parentId = null) => {
    const items = props.categories.filter(
      (item) => item.parent_target_id === parentId,
    );

    return items.map((item) => {
      const children = props.categories.filter(
        (child) => child.parent_target_id === item.value,
      );

      if (children.length > 0) {
        if (!item.has_create_permission) {
          return null;
        }

        return (
          <NestedMenuItem
            key={`cat-${item.value}`}
            rightIcon={<ChevronRight />}
            leftIcon={null}
            parentMenuOpen={open}
            label={decodeHtmlEntities(item.label)}
            MenuProps={menuProps}
            className="settings-nested"
            onClick={() => {
              props.handleCategorySelection(item.value);
              setOpen(false);
            }}
          >
            {renderMenuItems(item.value)}
          </NestedMenuItem>
        );
      }

      if (!item.has_create_permission) {
        return null;
      }

      return (
        <MenuItem
          key={`cat-${item.value}`}
          value={item.value}
          sx={{
            fontSize: "16px",
            fontWeight: "400",
            "&.Mui-selected": {
              backgroundColor: "primary.light",
            },
          }}
          onClick={() => {
            props.handleCategorySelection(item.value);
            setOpen(false);
          }}
        >
          {decodeHtmlEntities(item.label)}
        </MenuItem>
      );
    });
  };

  const menuProps = {
    anchorOrigin: {
      vertical: "top",
      horizontal: "left",
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "right",
    },
    PaperProps: { style: { pointerEvents: "auto" } },
  };

  const handleCategory = (value) => {
    props.handleCategorySelection(value);
    setOpen(false);
  };

  return (
    <FormControl variant="standard" fullWidth size="small">
      <InputLabel
        sx={{ fontSize: input_font_size }}
        size="small"
        id="category-select-label"
      >
        {props.title || "Category"}
      </InputLabel>
      <Select
        labelId={`${props.categoryName}-category-select-label`}
        id={`${props.categoryName}-category-select`}
        value={props.selectedCategoryItem}
        label={props.title}
        open={open}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        renderValue={(selected) => {
          const stringified = String(selected);

          if (!stringified || stringified === "0") return "All Categories";
          const found = props.categories.find((c) => c.value === stringified);

          return found ? decodeHtmlEntities(found.label) : "All Categories";
        }}
        input={
          <Input
            sx={{
              fontSize: input_font_size,
              "&.MuiInput-underline:before": {
                borderBottomColor: "#d2d0cf",
              },
            }}
            label="Category"
          />
        }
      >
        {allCategoryValues.map((id) => (
          <MenuItem
            key={`register-${id}`}
            value={id}
            sx={{ display: "none" }}
          />
        ))}

        {/* Visible top-level All Categories */}
        {!props.hideZero && (
          <MenuItem
            key="all-categories"
            value={0}
            sx={{ fontSize: input_font_size }}
            onClick={() => handleCategory(0)}
          >
            All Categories
          </MenuItem>
        )}
        {renderMenuItems(null)}
      </Select>
    </FormControl>
  );
}
